import cn from 'classnames';
import { Avatar, type AvatarProperties } from '../../avatar';
import { Button } from '../../button';
import { Flex } from '../../flex';
import styles from './conversation-item.module.css';
import { ConversationSummary, type ConversationSummaryProperties } from './conversation-summary';
import { Preview, type PreviewProperties } from './preview';
import { UnreadIndicator } from './unread-indicator';

export type MessagesSidebarItemConversationProperties = {
  avatar: AvatarProperties;
  conversationSummary: ConversationSummaryProperties;
  onClick?: () => void;
  preview: PreviewProperties;
  selected?: boolean;
};

const ConversationItem = ({
  avatar,
  conversationSummary: { actions, timestamp, title, unread },
  onClick,
  preview: { lastMessage, seenBy },
  selected,
}: MessagesSidebarItemConversationProperties) => (
  <Button block classNames={{ root: styles.button }} onClick={onClick} type={selected ? 'secondary' : 'text'}>
    <Flex align="center" className={cn(styles.root)} gap="xs">
      {unread ? <UnreadIndicator /> : null}
      <Avatar size="lg" {...avatar} borderColor="white" />
      <Flex className={styles.content} flex={1} gap="xxs" vertical>
        <ConversationSummary
          actions={{ className: cn(styles.actions, actions?.className), items: actions?.items }}
          timestamp={timestamp}
          title={title}
          unread={unread}
        />
        <Preview lastMessage={lastMessage} seenBy={seenBy} unread={unread} />
      </Flex>
    </Flex>
  </Button>
);

export default ConversationItem;
